import clsx from 'clsx';
import React from 'react';

interface TagProps {
  className?: string;
  name: string;
}

const Tag = ({ name, className }: TagProps) => {
  return (
    <span
      className={clsx(
        'whitespace-nowrap rounded-28 bg-grayscale-beige px-24 py-6 font-suisse-intl-mono text-overline-sm leading-normal text-black dark:bg-grayscale-gray',
        className
      )}
    >
      {name}
    </span>
  );
};

export default Tag;
